module.exports = __webpack_public_path__ + "img/16.55241c8.png";